import { useStore } from 'vuex';

import { logoutAndRedirect } from '@satellite/helpers/logoutAndRedirect';

export function useLogout() {
  const store = useStore();

  const logout = () => logoutAndRedirect(() => store.dispatch('Auth/logout'));

  return { logout };
}
